import { render, staticRenderFns } from "./MenuRedirect.vue?vue&type=template&id=e17e28ea&"
import script from "./MenuRedirect.vue?vue&type=script&lang=js&"
export * from "./MenuRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports